import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  AreaChart,
  Area,
  ReferenceLine,
  Brush,
} from "recharts";
import { connect } from "react-redux";
const PriceChart: React.FC = (props: any) => {
  const { reportData, loadingReport } = props;
  const lineData = props.reportData?.slice(1).map((item: any) => ({
    date: item[0],
    price: item[1],
  })) || [];
  const first = lineData[0]?.price;
  const last = lineData[lineData.length - 1]?.price;
  const change = ((last - first) / first) * 100;
  const isUp = change >= 0;
  const prices = lineData.map((item: any) => item.price);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  const range = maxPrice - minPrice;
  const padding = Math.max(range * 0.06, 0.3);
  const formatPrice = (value: number) => {
     if (value === undefined || value === null) {
      return "-";
    }
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2,
    });
  };
  const formatDate = (value: string) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}/${month}`;
  };
  if (loadingReport) {
    return <div className="text-gray-500">Loading report...</div>;
  }

  return (
    <div className="w-full h-[400px] bg-white rounded-xl p-4 shadow">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <div className="text-3xl font-bold text-gray-900">
            {formatPrice(last)}
          </div>
          <div
            className={`text-base font-semibold ${
              isUp ? "text-green-600" : "text-red-600"
            }`}
          >
            {change > 0 ? "+" : ""}
            {change.toFixed(2)}%
          </div>
        </div>

        <div className="text-sm text-gray-500">
          Range: {formatPrice(minPrice)} - {formatPrice(maxPrice)}
        </div>
      </div>
      <ResponsiveContainer width="100%" height={450}>
        <AreaChart
          data={lineData}
          margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
        >
          <defs>
            <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="date"
            tickFormatter={formatDate}
            interval="preserveStartEnd"
            minTickGap={30}
          />
          <YAxis
            domain={[minPrice - padding, maxPrice + padding]}
            tickFormatter={(value) => formatPrice(Number(value))}
            tick={{ fontSize: 12, fill: "#6b7280" }}
            width={70}
          />
          <Tooltip
            formatter={(value: any) => [formatPrice(Number(value)), "Price"]}
            labelFormatter={(label) => `Ngày: ${label}`}
            contentStyle={{
              backgroundColor: "#111827",
              border: "none",
              borderRadius: "10px",
              color: "#fff",
              boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
            }}
            labelStyle={{ color: "#cbd5e1" }}
          />
          <ReferenceLine
            y={last}
            stroke={isUp ? "#16a34a" : "#ef4444"}
            strokeDasharray="4 4"
          />
          <Area
            type="monotone"
            dataKey="price"
            stroke="#2563eb"
            strokeWidth={2.5}
            fill="url(#colorPrice)"
            activeDot={{ r: 6 }}
          />
          <Brush
            dataKey="date"
            height={30}
            stroke="#2563eb"
            travellerWidth={10}
            tickFormatter={formatDate}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
const mapStateToProps = (state: any) => {
  console.log("Symbol: ", state);
  return {
    reportData: state.report.reportData,
    loadingReport: state.report.loading,
  };
};
export default connect(mapStateToProps)(PriceChart);
